<div *transloco="let t; read 'customer.implementation-plan'">
  <table class="w-full">
    <thead class="border-b border-blue1">
    <tr class="[&>*]:p-2">
      <th class="text-left border-blue1 border-r"></th>
      <th class="text-left">{{t('name')}}</th>
      <th class="text-left">{{t('contact')}}</th>
      <th class="text-right">{{t('offer_status')}}</th>
      <th class="text-right">{{t('request_status')}}</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td colspan="4">
      </td>
    </tr>
    <tr *ngFor="let companyWithOffer of companies; let i = index; let even = even"
        @popInOut
        [ngClass]="{'bg-blue3': even, 'bg-sun-yellow': !even}" class="bg-opacity-10 [&>*]:p-2">
      <td class="border-blue1 border-r">{{i + 1}}.</td>
      <td>{{companyWithOffer.company.companyName}}</td>
      <td>{{companyWithOffer.company.email}}</td>
      <td
        class="text-right">{{companyWithOffer.implementationCompanyData?.offerAmount ? (companyWithOffer.implementationCompanyData?.offerAmount + ' ' + currency) : '-'}}</td>
      <!--    t(customer.implementation-plan.status.WAITING, customer.implementation-plan.status.OFFER, customer.implementation-plan.status.DONE, customer.implementation-plan.status.CANCELLED)  -->
      <td class="text-right">{{t('status.' + companyWithOffer.implementationCompanyData?.offerStatus)}}</td>
      <td>
        <mat-icon
          [matTooltip]="t('delete')"
          matTooltipPosition="above"
          (click)="deleteEntryClicked(companyWithOffer)"
          class="text-red-500 mt-1 cursor-pointer hover:opacity-60">delete
        </mat-icon>
      </td>
    </tr>
    <tr *ngIf="!companies || companies.length === 0">
      <td colspan="100" class="text-center">
        {{t('no_entries')}}
      </td>
    </tr>
    </tbody>
  </table>

</div>
